import { ActionModalProvider } from "context/ActionModalProvider";
import { AgrochemichalsProvider } from "context/AgrochemichalsProvider";
import { CropStressesProvider } from "context/CropStressesProvider";

const BulkActionWrapper = ({ children, cropId, isBio }) => {
  return (
    <CropStressesProvider cropId={cropId}>
      <AgrochemichalsProvider cropId={cropId}>
        <ActionModalProvider>{children}</ActionModalProvider>
      </AgrochemichalsProvider>
    </CropStressesProvider>
  );
};

export default BulkActionWrapper;
